import { useState, useEffect } from "react";
import { useNavigate } from "react-router";

import { currentUser } from "./../../Config/Data";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import { usePostForm } from "../../Api";
import { useNotification } from '../../Components/GlobalNotification';

import './style.css'

const ChangePassword = () => {
  const { showNotification } = useNotification();

    const navigate = useNavigate()

    const [userData, setUserData] = useState({});

    const [showModal, setShowModal] = useState(false);

    const [form, setForm] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });

    const {
        ApiData: ChangePasswordData,
        loading: ChangePasswordLoading,
        error: ChangePasswordError,
        post: PostChangePassword,
    } = usePostForm(`/change-password`);

    const handleFieldChange = (key) => (e) => {
        setForm((prev) => ({ ...prev, [key]: e?.target?.value ?? "" }));
    };

    const handleClickPopup = () => {
        if (!form.current_password || !form.new_password || !form.confirm_password) {
            showNotification({ type: 'error', title: 'Error', message: "Please fill all required fields." });
            return;
        }
        if (form.new_password !== form.confirm_password) {
            showNotification({ type: 'error', title: 'Error', message: "New password and confirm password do not match." });
            return;
        }

        PostChangePassword({
            current_password: form.current_password,
            new_password: form.new_password,
            confirm_password: form.confirm_password,
        });
    };

    useEffect(() => {

        document.title = 'kvr User | Change Password';

        setUserData(currentUser);
    }, []);

    useEffect(() => {
        if (ChangePasswordError) {
            const firstValidationError =
                ChangePasswordError?.errors?.current_password?.[0] ||
                ChangePasswordError?.errors?.new_password?.[0] ||
                ChangePasswordError?.errors?.confirm_password?.[0];

            showNotification({ type: 'error', title: 'Error', message: firstValidationError || ChangePasswordError?.message || "Failed to change password." });
        }
    }, [ChangePasswordError]);

    useEffect(() => {
        if (!ChangePasswordData) return;
        showNotification({ type: 'success', title: 'Success', message: ChangePasswordData?.message || "Password updated." });
        setShowModal(true);
    }, [ChangePasswordData]);

    return (
        <>
            <DashboardLayout>
                <div className="dashCard mb-4">
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="mainTitle">
                                <BackButton />
                                <span className="px-2">Change Password</span>
                            </h2>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-xl-4 col-lg-4">
                            <form>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <CustomInput
                                            label="Current Password"
                                            labelClass="mainLabel"
                                            required
                                            type="password"
                                            placeholder="Enter Current Password"
                                            inputClass="mainInput"
                                            value={form.current_password}
                                            onChange={handleFieldChange("current_password")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <CustomInput
                                            label="New Password"
                                            labelClass="mainLabel"
                                            required
                                            type="password"
                                            placeholder="Enter New Password"
                                            inputClass="mainInput"
                                            value={form.new_password}
                                            onChange={handleFieldChange("new_password")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <CustomInput
                                            label="Confirm New Password"
                                            labelClass="mainLabel"
                                            required
                                            type="password"
                                            placeholder="Confirm New Password"
                                            inputClass="mainInput"
                                            value={form.confirm_password}
                                            onChange={handleFieldChange("confirm_password")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <CustomButton
                                            type="button"
                                            variant="primaryButton"
                                            className="me-3 mb-2"
                                            text={ChangePasswordLoading ? "Updating..." : "Update"}
                                            onClick={handleClickPopup}
                                            disabled={ChangePasswordLoading}
                                        />
                                    </div>
                                  
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <CustomModal
                    show={showModal}
                    close={() => {
                        setShowModal(false);
                        navigate("/profile");
                    }}
                    success
                    heading='Your Password is Successfully Updated!'
                />
            </DashboardLayout>
        </>
    );
};

export default ChangePassword;
